 import JsonObj from './jinritushu.cn'
 //  import JsonObj from './jinritushu.com'

 export default JsonObj;